<template>
    <div class="app">
        <!--! 底色会遮盖轮播图 new-bac -->
        <jycheader :navIndex="0"></jycheader>

        <div class="index_box dis-cen">
            <!--轮播----------------------->
            <div
                style="width:1200px"
                class="dis-between"
            >
                <headerSwiper style="margin: 14px 0 0 0;"></headerSwiper>
                <!--:data="swiperData"-->
                <div class="index-right-box">
                    <div style="padding: 0 14px;box-sizing: border-box;">
                        <div class="dis index-icon-box">
                            <img
                                style="width:50px;height:50px;margin:auto 24px auto 11px"
                                src="../../assets/image/iocn/TX.png"
                            />
                            <div
                                v-if="is_token"
                                style="margin:auto 0"
                            >
                                <img
                                    v-if="vipCard"
                                    style="width:45px;height:20px"
                                    src="../../assets/image/iocn/huiyuan2.png"
                                />
                                <div
                                    v-else
                                    class="index-icon-box-p"
                                    @click="openVipClick"
                                >开通VIP</div>
                                <div class="index-box-p">{{username}}</div>
                            </div>
                            <div
                                v-else
                                style="margin:auto 0"
                                @click="go_login"
                            >
                                <div class="index-box-p">您好，</div>
                                <div class="index-box-p">欢迎来到厨房网</div>
                            </div>
                        </div>
                    </div>

                    <div
                        class="dis-between"
                        style="border-bottom: 1px solid #f1f1f1;padding: 0 14px;
    box-sizing: border-box;"
                    >
                        <div
                            class="index-model-box dis-cen"
                            @click="userBoxClick(1)"
                        >
                            <div style="margin:0 0 5px 0">{{all_order}}</div>
                            <div style="color:#434343">全部订单</div>
                        </div>
                        <div
                            class="index-model-box dis-cen"
                            @click="userBoxClick(2)"
                        >
                            <div style="margin:0 0 5px 0">{{send_goods}}</div>
                            <div style="color:#434343">待付款</div><!--待发货-->
                        </div>
                        <div
                            class="index-model-box dis-cen"
                            @click="userBoxClick(3)"
                        >
                            <div style="margin:0 0 5px 0">{{receiving_goods}}</div>
                            <div style="color:#434343">待收货</div>
                        </div>
                    </div>

                    <div class="dis">
                        <div
                            class="dis-cen index-img-wid"
                            @click="userBoxClick(4)"
                        >
                            <img src="../../assets/image/iocn/dingdan.png" />
                            <div>我的订单</div>
                        </div>
                        <div
                            class="dis-cen index-img-wid"
                            @click="userBoxClick(5)"
                        >
                            <img src="../../assets/image/iocn/shouhou.png" />
                            <div>我的售后</div>
                        </div>
                        <div
                            class="dis-cen index-img-wid"
                            @click="userBoxClick(6)"
                        >
                            <img src="../../assets/image/iocn/soucang.png" />
                            <div>我的关注</div>
                        </div>
                        <div
                            class="dis-cen index-img-wid"
                            @click="userBoxClick(7)"
                        >
                            <img src="../../assets/image/iocn/pingjia.png" />
                            <div>我的评价</div>
                        </div>
                        <div
                            class="dis-cen index-img-wid"
                            @click="userBoxClick(8)"
                        >
                            <img src="../../assets/image/iocn/dizhi.png" />
                            <div>收货地址</div>
                        </div>
                        <div
                            class="dis-cen index-img-wid"
                            @click="userBoxClick(9)"
                        >
                            <img src="../../assets/image/iocn/menybox.png" />
                            <div>我的钱包</div>
                        </div>
                        <div
                            class="dis-cen index-img-wid"
                            @click="userBoxClick(10)"
                        >
                            <img src="../../assets/image/iocn/jf.png" />
                            <div>积分转让</div>
                        </div>
                    </div>




                </div>
            </div>
            <!-- <div class="index_top">
                <div class="index_tops">
                    <div class="index_topsbox">
                        <div class="index_topsx">
                            <div class="index_topsxA">
                                <div class="index_topsxAimg"></div>
                                <div class="index_topsxAcent">
                                    <p>新手上路</p>
                                    <h4>新用户演示</h4>
                                </div>
                            </div>
                            <div class="index_topsxA">
                                <div class="index_topsxAimgA"></div>
                                <div class="index_topsxAcent">
                                    <p>付款方式</p>
                                    <h4>常见支付问题</h4>
                                </div>
                            </div>
                        </div>
                        <div class="index_topsk">
                            <div class="index_topskcent">
                                <p>客服热线</p>
                                <div class="index_topskimgs"></div>
                            </div>
                        </div>
                        <div class="index_topsr">
                            <input placeholder="找不到,试试搜索" />
							<div class="index_topsrbox">搜索</div>
							<div class="index_topsrts">
								<p>
									热门搜索:
									<span v-for="(item,index) in search" :key="index">
										{{item.name}}
									</span>
								</p>
							</div>
                            <div class="joinus-btn">
                                <div class="joinus">加盟我们</div>
                            </div>
                        </div>
                    </div>
                    <div class="index_anno">
						<div class="index_animgs"></div>
						<h4>每日公告</h4>
						<p v-for="(item,index) in announcement" :key="index">
							{{item.test}}
						</p>
					</div>
                </div>
            </div> -->
            <!-- <el-backtop :bottom="100">
                <div style="
                         {
                            height: 100%;
                            width: 100%;
                            border-radius: 100px;
                            background-color: #f2f5f6;
                            box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
                            text-align: center;
                            line-height: 40px;
                            color: #569516;
                        }
                    ">
                    <i class="el-icon-upload2"></i>
                </div>
            </el-backtop> -->
        </div>
        <!--v-if="is_token && !vipCard"-->
        
        <div v-if="!vipCard && is_banner" class="index-img-pos">
            <div class="dis-end"><img @click="closeBannerClick" style="width:25px;height:auto;cursor:pointer;margin:0 0 10px 0" src="../../assets/image/iocn/close.png"/></div>
            <img
                style="width:100%;height:auto"
                @click="openVipClick"
                src="../../assets/image/iocn/huiyuan.png"
            />
        </div>
        <div v-if="is_wximg" class="index-img-pos-left">
            <div><img @click="closeWxClick" style="width:25px;height:auto;cursor:pointer;margin:0 0 10px 0" src="../../assets/image/iocn/close.png"/></div>
            <img
                style="width:90%;height:auto"
                src="../../assets/image/iocn/wxxcx.png"
            />
        </div>
        <!--开通会员-->
        <!-- 公共的类目 -------->
        <!-- <Column></Column> -->
        <!-- 为您推荐 ------------------->
        <!-- <recommend></recommend> -->
        <!--名小吃---->
        <famous-snacks></famous-snacks>
        <!--本地小吃-->
        <famous-snacks-locality></famous-snacks-locality>
        <!-- 折扣专区 ------------------->
        <discount></discount>
        <Content :data="vegetables"></Content>
        <content2
            :data="seasoning"
            :datas="seasonings"
        ></content2>
        <childcompany></childcompany>
        <jycbottom></jycbottom>
    </div>
</template>

<script>
    import jycheader from "../header.vue";
    import jycbottom from "./bottoms.vue";
    import Column from "./column.vue";
    import Content from "./content.vue";
    import headerSwiper from "../indexComponents/headerSwiper.vue";
    import recommend from "../indexComponents/recommend.vue";
    import content2 from "./content2.vue";
    import childcompany from "../indexComponents/childcompany.vue";
    import discount from "./discount"
    import famousSnacks from "./famousSnacks"
import FamousSnacksLocality from './famousSnacksLocality.vue';

    export default
    {
        name: "App",
        components:
        {
            jycheader,
            jycbottom,
            Column,
            Content,
            headerSwiper,
            recommend,
            content2,
            childcompany,
            discount,
            famousSnacks,
                FamousSnacksLocality
        },
        data()
        {
            return {
                is_token: false,
                is_banner: false,
                is_wximg: false,
                vipCard: '',
                username: '--',
                all_order: '--',
                send_goods: '--',
                receiving_goods: '--',
                // +-----------------------
                search: [
                {
                    name: "西瓜",
                },
                {
                    name: "白菜",
                },
                {
                    name: "五花肉",
                },
                {
                    name: "茄子",
                }, ],
                vegetables: [],
                seasoning: [],
                seasonings: [],
            };
        },
        created()
        {
            window.scroll(0, 0)
            this.is_banner = true
            this.is_wximg = true
            this.$loading();
            if ( localStorage.getItem( 'token' ) ) this.is_token = true
            this.username = localStorage.getItem( 'username' )
            localStorage.setItem( 'userStatusHTop', '' );
            localStorage.removeItem( 'divType' )
            // +---------------------------------------------------------------
            this.vipCard = localStorage.getItem( 'vipCard' ) != 'null' ? localStorage.getItem( 'vipCard' ) : ''
            this.asdFn()
            this.addressFn()

        },
        mounted()
        {
            this.productList();
            this.ipLonFn()
        },
        methods:
        {
            closeBannerClick() {
                this.is_banner = false
            },
            closeWxClick() {
                this.is_wximg = false
            },
            addressFn() {
                // ！ip定位到城市无法定位区县（取收货地址的坐标）
                let params = {PageNo: 1,PageSize: 30}
				this.$api.order.getAddress(params).then(res => {
					if (res.data.code == 0) {
						let addressList = res.data.result.data
                        if (addressList.length == 0) {
                            this.$confirm( '请先添加收货地址？', '提示',
                            {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then( () =>
                            {
                                this.$router.push( { path: '/order?index=0&personal=5' } )
                            }).catch( () =>
                            {
                                // ...
                            })
                        } else if (!JSON.parse( localStorage.getItem( 'marketActObj' ) )) {
                            localStorage.setItem( 'v_addressListData', JSON.stringify( addressList ) )
                            // this.$confirm( '请先选择菜场？', '提示',
                            // {
                            //     confirmButtonText: '确定',
                            //     cancelButtonText: '取消',
                            //     type: 'warning'
                            // }).then( () =>
                            // {
                            //     this.$router.push( { path: '/marketlist?num=1' } )
                            // }).catch( () =>
                            // {
                            //     // ...
                            // })
                        }
					} else {
						// let name = res.data.message
						// this.checkTips(name, "warning")
					}
				})
            },
            asdFn() {
                // ！修复 h-top 中接口 GetUserInfo 与本页赋值异步的bug
                let that= this
                setTimeout(function(){
                    that.vipCard = localStorage.getItem( 'vipCard' ) != 'null' ? localStorage.getItem( 'vipCard' ) : ''
                }, 2000)
            },
            ipLonFn() {
                let url = 'https://apis.map.qq.com/ws/location/v1/ip?key=E25BZ-BENKD-2UZ4S-HXOGB-SKWI3-NFBED'
                this.$jsonp(url, {
                    output: "jsonp"
                }).then(res => {
                    console.log(res.result.location, 'IP定位的结果')
                    localStorage.setItem('longLat', JSON.stringify(res.result.location))
                }).catch(err => {
                    // alert(err)
                })
            },
            // +----------------------------------------
            openVipClick()
            {
                if ( !this.is_token )
                {
                    this.$confirm( '开通会员需要登录, 是否前往登录?', '提示',
                    {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    } ).then( () =>
                    {
                        this.go_login()
                    } ).catch( () =>
                    {
                        this.$message(
                        {
                            type: 'info',
                            message: '已取消'
                        } )
                    } )

                    return
                }
                localStorage.setItem( 'divType', 1 );
                this.$router.push( { path: '/regist?num=1' } )
            },
            go_login()
            {
                this.$router.push(
                {
                    path: '/login'
                } )
            },
            userBoxClick( val )
            {
                if ( !this.is_token )
                {
                    this.$confirm( '此操作需要登录, 是否前往登录?', '提示',
                    {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    } ).then( () =>
                    {
                        this.go_login()
                    } ).catch( () =>
                    {
                        this.$message(
                        {
                            type: 'info',
                            message: '已取消'
                        } )
                    } )
                    return
                }
                if ( val == 1 )
                {
                    //全部订单
                    localStorage.setItem( 'personal', 0 )
                    this.$router.push(
                    {
                        path: "/order",
                        query:
                        {
                            index: 0
                        }
                    } )
                }
                else if ( val == 2 )
                {
                    localStorage.setItem("orderTitleValue", 2)
                    localStorage.setItem( 'personal', 0 )
                    this.$router.push(
                    {
                        path: "/order",
                        query:
                        {
                            index: 0
                        }
                    } )
                }
                else if ( val == 3 )
                {
                    localStorage.setItem("orderTitleValue", 4)
                    localStorage.setItem( 'personal', 0 )
                    this.$router.push(
                    {
                        path: "/order",
                        query:
                        {
                            index: 0
                        }
                    } )
                }
                else if ( val == 4 )
                {
                    //我的订单
                    localStorage.setItem( 'personal', 0 )
                    this.$router.push(
                    {
                        path: "/order",
                        query:
                        {
                            index: 0
                        }
                    } )

                }
                else if ( val == 5 )
                {
                    // ??? 未完成
                }
                else if ( val == 6 )
                {
                    //我的关注
                    localStorage.setItem( 'personal', 1 )
                    this.$router.push(
                    {
                        path: '/order',
                        query:
                        {
                            index: 1,
                            personal: 1
                        }
                    } )

                }
                else if ( val == 7 )
                {
                    // ??? 未完成
                }
                else if ( val == 8 )
                {
                    //我的信息
                    localStorage.setItem( 'personal', 5 )
                    this.$router.push(
                    {
                        path: '/order',
                        query:
                        {
                            index: 0,
                            personal: 5
                        }
                    } )

                } else if ( val == 9 )
                {
                    //我的钱包
                    localStorage.setItem( 'personal', 2 )
                    this.$router.push(
                    {
                        path: '/order',
                        query:
                        {
                            index: 0,
                            personal: 2
                        }
                    } )

                } else if ( val == 10 )
                {
                    localStorage.setItem( 'personal', 7 )
                    this.$router.push(
                    {
                        path: '/order',
                        query:
                        {
                            index: 0,
                            personal: 7
                        }
                    } )
                }
            },
            // +-----------------------------------------
            productList()
            {
                let cityname = JSON.parse( localStorage.getItem( 'cityname' ) )
                let addId = {
                    "cityId":cityname.twoId,
                    "regionId":cityname.threeId > 0?cityname.threeId: null
                }
                //首页列表展示
                this.$api.product.productList(addId).then( ( res ) =>
                {
                    this.$loading().close();
                    let data = res.data.result;
                    this.vegetables = data.slice( 0, 2 );
                    this.seasoning = data.slice( 2, 4 );
                    this.seasonings = data.slice( 4.5 );
                    // console.log(data)
                } );
            },
        },
        computed: {},
    };
</script>

<style scoped="scoped">
    .joinus {
        width: 14.7875rem;
        height: 2.375rem;
        text-align: center;
        color: #ffffff;
        border: 1px solid #ffffff;
        line-height: 2.375rem;
    }

    .joinus-btn {
        width: 15.5625rem;
        height: 3rem;
        background-color: #37a115;
        padding: 5px 6px;
        box-sizing: border-box;
        cursor: pointer;
    }

    .index_box {
        width: 100%;
        height: 100%;
    }

    .index_top {
        width: 100%;
        height: 153px;
        background: #ffffff;
        /* display: flex;
		justify-content: center; */
        position: relative;
        /* margin: auto; */
    }

    .index_tops {
        width: 75rem;
        height: 11.875rem;
        position: absolute;
        left: 50%;
        top: 0;
        transform: translate(-50%);
        z-index: 99;
    }

    .index_topsbox {
        width: 100%;
        height: 8.25rem;
        background: #ffffff;
        margin-top: -2.5rem;
        display: flex;
        box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.5);
    }

    .index_topsx {
        display: flex;
        justify-content: space-around;
        width: 33.4375rem;
        border-right: 1px solid #f1f1f1;
        height: 5.5625rem;
        margin-top: 1.2rem;
    }

    .index_topsk {
        width: 18.75rem;
        height: 5.5625rem;
        border-right: 1px solid #e7e7e7;
        margin-top: 1.2rem;
    }

    .index_topsr {}

    .index_topsxA {
        display: flex;
        height: 100%;
        width: 13.75rem;
        margin-top: 1rem;
    }

    .index_topsxAimg {
        background: url("../../assets/image/iocn/iocnfont.png") no-repeat -9px -29px;
        width: 52px;
        height: 52px;
    }

    .index_topsxAimgA {
        background: url("../../assets/image/iocn/iocnfont.png") no-repeat -78px -29px;
        width: 52px;
        height: 52px;
    }

    .index_topsxAcent {
        margin: -0.6rem 1rem;
    }

    .index_topsxAcent p {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        line-height: 34px;
        border-bottom: 1px solid #f1f1f1;
        width: 8rem;
    }

    .index_topsxAcent h4 {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 34px;
    }

    .index_topskimgs {
        background: url("../../assets/image/iocn/iocnfont.png") no-repeat -147px -40px;
        width: 188px;
        height: 29px;
        margin-top: 0.8rem;
    }

    .index_topskcent {
        margin: 0.4rem 3rem;
    }

    .index_topskcent p {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        line-height: 34px;
        width: 12.625rem;
        border-bottom: 1px solid #f1f1f1;
    }

    .index_topsr {
        margin: 2rem 2.6rem;
    }

    .index_topsr input {
        width: 17.0625rem;
        height: 2.4375rem;
        border: 1px solid #bfbfbf;
        outline: none;
        font-size: 15px;
    }

    .index_topsrbox {
        width: 4.875rem;
        height: 2.4375rem;
        background: #6ebc1f;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        line-height: 38px;
        text-align: center;
        position: absolute;
        margin: -2.5rem 12.3rem;
        cursor: pointer;
    }

    .index_topsrts {
        margin-top: 0.5rem;
    }

    .index_topsrts p {
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        line-height: 34px;
    }

    .index_anno {
        display: flex;
        margin-top: 1rem;
    }

    .index_anno h4 {
        font-size: 20px;
        font-family: SourceHanSerifSC;
        font-weight: bold;
        color: #333333;
        line-height: 34px;
        margin-left: 1rem;
    }

    .index_anno p {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        line-height: 34px;
        margin-left: 1rem;
    }

    .index_animgs {
        background: url("../../assets/image/iocn/iocnfont.png") no-repeat -64px -5px;
        width: 18px;
        height: 14px;
        margin-top: 0.7rem;
    }

    /********************************/
    .switch {
        width: 928px;
        margin: 14px auto 10px 0;
        /* border-radius: 20px; */
        overflow: hidden;
    }

    .discount-layer {
        width: 1200px;
        margin: 0 auto;
    }

    .layer-header {
        width: 310px;
        height: 90px;
        background: #F7F7F7;
        border-radius: 45px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding: 15px 33px;
        margin: 20px auto 40px;
    }

    .layer-header .bg {
        width: 61px;
        height: 59px;
        background-repeat: no-repeat;
        background-size: 100%;

    }

    /* .discount-layer-foor:nth-child(1) .bg {
        background-image: url('../../assets/image/img/折扣页/xia.png');
    }

    .discount-layer-foor:nth-child(2) .bg {
        background-image: url('../../assets/image/img/折扣页/roulei.png');
    }

    .discount-layer-foor:nth-child(3) .bg {
        background-image: url('../../assets/image/img/折扣页/shuiguo.png');
    }

    .discount-layer-foor:nth-child(4) .bg {
        background-image: url('../../assets/image/img/折扣页/tecan.png');
    }

    .discount-layer-foor:nth-child(5) .bg {
        background-image: url('../../assets/image/img/折扣页/shucai.png');
    } */


    .layer-header .tit {
        font-size: 36px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #11D165;
        flex: 1;
        margin-left: 35px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .layer-goods-list {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
    }

    .goods-item {
        width: 590px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 20px 17px;
        background: #F7F7F7;
        border-radius: 20px;
        margin-bottom: 20px;
    }

    .goods-item .pic {
        width: 180px;
        height: 180px;
        display: block;
    }

    .goods-item .goods_info {
        flex: 1;
        margin-left: 45px;
    }

    .goods-item .goods_info .name {
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #434343;
        margin-bottom: 13px;
    }

    .goods-item .goods_info .weight {
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #FF4949;
        margin-bottom: 20px;
    }

    .goods-item .price {
        margin-bottom: 20px;
    }

    .goods-item .price .x_price {
        margin-right: 70px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #FF4949;
    }

    .goods-item .price .x_price span.tip {
        background: #D9161C;
        border-radius: 5px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        padding: 3px 3px;
    }

    .goods-item .price .x_price span.rmb {
        font-size: 18px;
    }

    .goods-item .price .x_price span.p {
        font-size: 22px;

    }

    .goods-item .price .o_price {
        font-family: PingFang SC;
        font-weight: 500;
        text-decoration: line-through;
        color: #999999;
    }

    .goods-item .price .o_price .rmb {
        font-size: 18px;
    }

    .goods-item .price .o_price .p {
        font-size: 16px;
    }

    .a-button {
        display: block;
        width: 300px;
        height: 44px;
        line-height: 44px;
        background: #D9161C;
        border-radius: 5px;
        text-align: center;
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
    }

    .new-bac {
        background-color: #F7F7F7
    }

    @import '../../assets/style/base.css';
</style>